import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { map, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { AuthNewService } from "src/auth/services/auth-new.service";
import { NgxRolesService } from "ngx-permissions";
import { Apollo } from "apollo-angular";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService {
  constructor(
    private auth: AuthNewService,
    private router: Router,
    private rolesService: NgxRolesService,

    private apollo: Apollo
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.auth.auth$.pipe(
      take(1),
      map((auth) => {
        // TBD
        // return true;
        if (auth) {
          return true;
        }
        localStorage.removeItem("__way2vat.user");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("access_token");
        localStorage.removeItem("way2vat");

        this.apollo.use("extra").client.clearStore();
        this.apollo.use("wv").client.clearStore();
        this.apollo.use("phoenix").client.clearStore();

        this.rolesService.flushRolesAndPermissions();
        this.router.navigate(["/auth/sign-in"], {
          queryParams: { redirectUrl: state.url },
        });
      })
    );
  }
}
